module.exports = __webpack_public_path__ + "img/ig-icon.2e6cc210.svg";